// import React, { useEffect, useState } from 'react';
// import NewModal from './NewModal';
// import templatestyle from "./TemplateModal.module.css"
// // import manageStyle from "./Managestyles.module.css"
// import { InfoOutlineIcon } from "@chakra-ui/icons";
// import managestyle from "./manageprojectstyles.module.css"
// import { epl } from '../../clientstyles/epl';
// import { edp } from '../../clientstyles/edp';
// import { eplStyles } from '../../clientstyles/commonstyles';
// const ManageProjectStyle = ({ SettingsModal, styleRef, setSettingsModal, setSelectedClientStyles, setShowDescription, searchingStyles, handleCheckChange, setSelectedDescription, selecteddescription, handleStore, filteredStyles, selectedClientStyles, searchStyles, item }) => {
//     const combinedStyles = [
//         ...Object.keys(epl).map(key => ({ name: key, source: 'EPL', data: epl[key] })),
//         ...Object.keys(edp).map(key => ({ name: key, source: 'EDP', data: edp[key] })),
//         ...Object.keys(eplStyles).map(key => ({ name: key, source: 'Common', data: eplStyles[key] }))
//     ];
//     const filtered = combinedStyles.filter(styleItem => {
//         const query = searchStyles.toLowerCase().trim();
//         if (!query) return true;

//         const nameMatches = styleItem.name.toLowerCase().includes(query);
//         const sourceMatches = styleItem.source.toLowerCase() === query;

//         return nameMatches || sourceMatches;
//     });

//     return (
//         <NewModal show={SettingsModal} >
//             <div ref={styleRef} className={managestyle.warningcontainer}>
//                 <div className={managestyle.TemplateHeaderContainer}>
//                     <p >Manage Styles</p>
//                     <button onClick={() => { setSettingsModal(false); setSelectedClientStyles([]); setShowDescription(false) }}>
//                         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                             <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                             <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                         </svg>
//                     </button>
//                 </div>
//                 <div className={managestyle.BothSideContainer}>
//                     <div className={managestyle.LeftsideContainer}>
//                         <div className={managestyle.stylePreviewContainer}>
//                             <h1 >Styles*</h1>
//                             <div style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: "20px",
//                             }}
//                             >
//                                 <input
//     style={{ marginLeft: "20px" }}
//     type="checkbox"
//     // Use 'filtered' instead of 'filteredStyles'
//     checked={selectedClientStyles.length === filtered.length && filtered.length > 0}
//     onChange={() => {
//         if (selectedClientStyles.length === filtered.length) {
//             setSelectedClientStyles([]);
//         } else {
//             // Map through 'filtered' to get the names
//             setSelectedClientStyles(filtered.map(item => item.name));
//         }
//     }}
// />

//                                 <div className={managestyle.searchContainer} style={{ flex: 1 }}>


//                                     <input type='text' value={searchStyles} onChange={searchingStyles}
//                                         className={managestyle.searchinput}
//                                     />
//                                     <svg className={managestyle.searchicon} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
//                                         <path d="M 9 2 C 5.1458514 2 2 5.1458514 2 9 C 2 12.854149 5.1458514 16 9 16 C 10.747998 16 12.345009 15.348024 13.574219 14.28125 L 14 14.707031 L 14 16 L 20 22 L 22 20 L 16 14 L 14.707031 14 L 14.28125 13.574219 C 15.348024 12.345009 16 10.747998 16 9 C 16 5.1458514 12.854149 2 9 2 z M 9 4 C 11.773268 4 14 6.2267316 14 9 C 14 11.773268 11.773268 14 9 14 C 6.2267316 14 4 11.773268 4 9 C 4 6.2267316 6.2267316 4 9 4 z"></path>
//                                     </svg>
//                                 </div>
//                             </div>


//                             <div className={managestyle.stylePreviewBox}>
//                                 {filtered.length > 0 ? (
//                                     filtered.map((item, index) => (
//                                         <div
//                                             // Use a combined key to handle duplicate names across sources
//                                             key={`${item.source}-${item.name}-${index}`}
//                                             style={{
//                                                 display: "flex",
//                                                 alignItems: "center",
//                                                 justifyContent: "space-between",
//                                                 gap: "10px",
//                                             }}
//                                             className={selecteddescription?.name === item.name && managestyle.currentDiscription}
//                                         >
//                                             <div className={managestyle.individualstyle} style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%" }}>

//                                                 {/* 1. CHECKBOX */}
//                                                 <input
//                                                     type="checkbox"
//                                                     // Note: If you want to select specifically by source, 
//                                                     // you might need to adjust handleCheckChange to accept item.source too
//                                                     checked={selectedClientStyles.includes(`${item.source}-${item.name}`)}
//                                                     onChange={() => handleCheckChange(`${item.source}-${item.name}`)}
//                                                 />

//                                                 {/* 2. LABEL & TAG CONTAINER */}
//                                                 <div
//                                                     onClick={(e) => {
//                                                         e.preventDefault();
//                                                         e.stopPropagation();
//                                                         setSelectedDescription({ name: item.name, value: item.data });
//                                                         setShowDescription(true);
//                                                     }}
//                                                     className={managestyle.individualstyle}
//                                                     style={{
//                                                         display: "flex",
//                                                         justifyContent: "space-between",
//                                                         alignItems: "center",
//                                                         width: "100%",
//                                                         cursor: "pointer"
//                                                     }}
//                                                 >
//                                                     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                                                         {/* 3. SOURCE TAG (EPL/EDP/Common) */}
//                                                         <span
//                                                             className={managestyle.styleLabels}
//                                                             data-source={item.source.toLowerCase()}
//                                                         >
//                                                             {item.source}
//                                                         </span>

//                                                         {/* 4. STYLE NAME */}
//                                                         <label className={managestyle.Textcolor}>
//                                                             {item.name}
//                                                         </label>
//                                                     </div>

//                                                     {/* 5. INFO ICON */}
//                                                     <button
//                                                         onClick={(e) => {
//                                                             e.preventDefault();
//                                                             e.stopPropagation();
//                                                             setSelectedDescription({ name: item.name, value: item.data });
//                                                             setShowDescription(true);
//                                                         }}
//                                                         style={{
//                                                             background: "none",
//                                                             border: "none",
//                                                             cursor: "pointer",
//                                                             padding: "5px"
//                                                         }}
//                                                     >
//                                                         <InfoOutlineIcon />
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     ))
//                                 ) : (
//                                     <p>No Styles</p>
//                                 )}
//                             </div>
//                         </div>


//                     </div>
//                     <div className={managestyle.RightsideContainer}>
//                         <div className={managestyle.descriptionViewContainer}>

//                             <div style={{
//                                 display: "flex",
//                                 justifyContent: "space-between",
//                                 alignItems: "center",
//                                 marginBottom: "20px"
//                             }}>
//                                 <h1 className={managestyle.Textcolor}>{selecteddescription?.name}</h1>
//                                 {/* <button
//                                         onClick={() => {
//                                             setShowDescription(false);
//                                             setSelectedDescription(null);
//                                         }}
//                                         className={manageStyle.nextbutton}
//                                         style={{ width: "auto", padding: "8px 20px" }}
//                                     >
//                                         Close
//                                     </button> */}
//                             </div>

//                             <div style={{ color: "#222" }}>
//                                 <h3 className={managestyle.Textcolor}>Description:</h3>
//                                 <p className={managestyle.Textcolor} style={{ paddingBottom: "10px" }}>{selecteddescription?.value?.description || "No description available"}</p>
//                                 <p className={managestyle.Textcolor} style={{ paddingBottom: "10px" }}>Before:</p>
//                                 {selecteddescription?.value?.beforeImage && (
//                                     <img
//                                         src={process.env.PUBLIC_URL + selecteddescription.value.beforeImage}
//                                         alt="After"
//                                         style={{ paddingBottom: "10px" }}
//                                     />
//                                 )}

//                                 <p className={managestyle.Textcolor} style={{ paddingBottom: "10px" }}>After:</p>
//                                 {selecteddescription?.value?.afterImage && (
//                                     <img
//                                         src={process.env.PUBLIC_URL + selecteddescription.value.afterImage}
//                                         alt="After"
//                                         style={{ paddingBottom: "10px" }}
//                                     />
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className={managestyle.nextbtn}>
//                     <button className={managestyle.nextbutton} onClick={() => handleStore(item)}>
//                         Next
//                     </button>
//                 </div>
//             </div>
//         </NewModal>
//     )
// }

// export default React.memo(ManageProjectStyle);




import React, { useEffect, useState } from 'react';
import NewModal from './NewModal';
import templatestyle from "./TemplateModal.module.css"
import { InfoOutlineIcon } from "@chakra-ui/icons";
import managestyle from "./manageprojectstyles.module.css"
import { epl } from '../../clientstyles/epl';
import { edp } from '../../clientstyles/edp';
import { eplStyles } from '../../clientstyles/commonstyles';

const ManageProjectStyle = ({ SettingsModal, styleRef, setSettingsModal, setSelectedClientStyles, setShowDescription, searchingStyles, handleCheckChange, setSelectedDescription, selecteddescription, handleStore, filteredStyles, selectedClientStyles, searchStyles, item }) => {
    const combinedStyles = [
        ...Object.keys(epl).map(key => ({ name: key, source: 'EPL', data: epl[key] })),
        ...Object.keys(edp).map(key => ({ name: key, source: 'EDP', data: edp[key] })),
        ...Object.keys(eplStyles).map(key => ({ name: key, source: 'Common', data: eplStyles[key] }))
    ];

    const filtered = combinedStyles.filter(styleItem => {
        const query = searchStyles.toLowerCase().trim();
        if (!query) return true;
        const nameMatches = styleItem.name.toLowerCase().includes(query);
        const sourceMatches = styleItem.source.toLowerCase() === query;
        return nameMatches || sourceMatches;
    });

    return (
        <NewModal show={SettingsModal} >
            <div ref={styleRef} className={managestyle.warningcontainer}>
                <div className={managestyle.TemplateHeaderContainer}>
                    <p >Manage Styles</p>
                    <button onClick={() => { setSettingsModal(false); setSelectedClientStyles([]); setShowDescription(false) }}>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                </div>
                <div className={managestyle.BothSideContainer}>
                    <div className={managestyle.LeftsideContainer}>
                        <div className={managestyle.stylePreviewContainer}>
                            <h1>Styles*</h1>
                            <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>

                                {/*
                                  ── SELECT-ALL CHECKBOX ─────────────────────────────────────────
                                  FIX 1: `checked` must compare against composite keys
                                         `${item.source}-${item.name}` — not plain item.name.
                                         Previously used filtered.length which would show "checked"
                                         even though individual boxes were all unchecked.

                                  FIX 2: the `onChange` deselect branch must clear using the same
                                         composite keys so the count comparison stays consistent.

                                  FIX 3: the `onChange` select branch must build composite keys
                                         so the individual checkbox `checked` prop finds matches.
                                */}
                                <input
                                    style={{ marginLeft: "20px" }}
                                    type="checkbox"
                                    // FIX 1: check how many composite keys from `filtered`
                                    // are currently in selectedClientStyles
                                    checked={
                                        filtered.length > 0 &&
                                        filtered.every(i => selectedClientStyles.includes(`${i.source}-${i.name}`))
                                    }
                                    onChange={() => {
                                        const allFilteredKeys = filtered.map(i => `${i.source}-${i.name}`);
                                        const allSelected = filtered.every(i =>
                                            selectedClientStyles.includes(`${i.source}-${i.name}`)
                                        );
                                        if (allSelected) {
                                            // FIX 2: deselect only the currently filtered items,
                                            // keep any other selections that are outside this filter
                                            setSelectedClientStyles(prev =>
                                                prev.filter(key => !allFilteredKeys.includes(key))
                                            );
                                        } else {
                                            // FIX 3: add composite keys for all filtered items
                                            // that aren't already selected
                                            setSelectedClientStyles(prev => [
                                                ...prev,
                                                ...allFilteredKeys.filter(key => !prev.includes(key))
                                            ]);
                                        }
                                    }}
                                />

                                <div className={managestyle.searchContainer} style={{ flex: 1 }}>
                                    <input
                                        type='text'
                                        value={searchStyles}
                                        onChange={searchingStyles}
                                        className={managestyle.searchinput}
                                    />
                                    <svg className={managestyle.searchicon} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24" >
                                        <path d="M 9 2 C 5.1458514 2 2 5.1458514 2 9 C 2 12.854149 5.1458514 16 9 16 C 10.747998 16 12.345009 15.348024 13.574219 14.28125 L 14 14.707031 L 14 16 L 20 22 L 22 20 L 16 14 L 14.707031 14 L 14.28125 13.574219 C 15.348024 12.345009 16 10.747998 16 9 C 16 5.1458514 12.854149 2 9 2 z M 9 4 C 11.773268 4 14 6.2267316 14 9 C 14 11.773268 11.773268 14 9 14 C 6.2267316 14 4 11.773268 4 9 C 4 6.2267316 6.2267316 4 9 4 z" stroke="currentColor"></path>
                                    </svg>
                                </div>
                            </div>

                            <div className={managestyle.stylePreviewBox}>
                                {filtered.length > 0 ? (
                                    filtered.map((item, index) => (
                                        <div
                                            key={`${item.source}-${item.name}-${index}`}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                gap: "10px",
                                            }}
                                            className={selecteddescription?.name === item.name && managestyle.currentDiscription}
                                        >
                                            <div className={managestyle.individualstyle} style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%" }}>

                                                {/* CHECKBOX — uses composite key, unchanged from original */}
                                                <input
                                                    type="checkbox"
                                                    checked={selectedClientStyles.includes(`${item.source}-${item.name}`)}
                                                    onChange={() => handleCheckChange(`${item.source}-${item.name}`)}
                                                />

                                                {/* LABEL & TAG CONTAINER */}
                                                <div
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setSelectedDescription({ name: item.name, value: item.data });
                                                        setShowDescription(true);
                                                    }}
                                                    className={managestyle.individualstyle}
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        width: "100%",
                                                        cursor: "pointer"
                                                    }}
                                                >
                                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                                        <span
                                                            className={managestyle.styleLabels}
                                                            data-source={item.source.toLowerCase()}
                                                        >
                                                            {item.source}
                                                        </span>
                                                        <label className={managestyle.Textcolor}>
                                                            {item.name}
                                                        </label>
                                                    </div>

                                                    <button
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            setSelectedDescription({ name: item.name, value: item.data });
                                                            setShowDescription(true);
                                                        }}
                                                        style={{
                                                            background: "none",
                                                            border: "none",
                                                            cursor: "pointer",
                                                            padding: "5px"
                                                        }}
                                                    >
                                                        <InfoOutlineIcon className={managestyle.Textcolor} />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <p>No Styles</p>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className={managestyle.RightsideContainer}>
                        <div className={managestyle.descriptionViewContainer}>
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "20px"
                            }}>
                                <h1 className={managestyle.Textcolor}>{selecteddescription?.name}</h1>
                            </div>
                            <div style={{ color: "#222" }}>
                                <h3 className={managestyle.Textcolor}>Description:</h3>
                                <p className={managestyle.Textcolor} style={{ paddingBottom: "10px" }}>
                                    {selecteddescription?.value?.description || "No description available"}
                                </p>
                                <p className={managestyle.Textcolor} style={{ paddingBottom: "10px" }}>Before:</p>
                                {selecteddescription?.value?.beforeImage && (
                                    <img
                                        src={process.env.PUBLIC_URL + selecteddescription.value.beforeImage}
                                        alt="Before"
                                        style={{ paddingBottom: "10px" }}
                                    />
                                )}
                                <p className={managestyle.Textcolor} style={{ paddingBottom: "10px" }}>After:</p>
                                {selecteddescription?.value?.afterImage && (
                                    <img
                                        src={process.env.PUBLIC_URL + selecteddescription.value.afterImage}
                                        alt="After"
                                        style={{ paddingBottom: "10px" }}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className={managestyle.nextbtn}>
                    <button className={managestyle.nextbutton} onClick={() => handleStore(item)}>
                        Next
                    </button>
                </div>
            </div>
        </NewModal>
    );
};

export default React.memo(ManageProjectStyle);
